import React from 'react';

import {Helmet} from 'views/module';

import AutomationsScene from 'views/scenes/automations/Automations';

const AutomationsPage = (props) => {
  return (
    <>
      <Helmet>
        <title>Quilt: Automations</title>
      </Helmet>
      <AutomationsScene />
    </>
  );
};

export default AutomationsPage;
